var _defs, _defs2, _defs3, _defs4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M163.6 164.2h1672.8V1837H163.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 1000,
    cy: 1000.6,
    r: 836.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.6 164.2h1672.8V1837H163.6V164.2z",
    style: {
      fill: "#fec112"
    }
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M15.6 16.1h1969v1969H15.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 16.1c-543.2 0-984.4 441.3-984.4 984.4 0 543.1 441.3 984.4 984.4 984.4 543.1 0 984.4-441.3 984.4-984.4 0-543.1-441.3-984.4-984.4-984.4zm0 42.8c520.6 0 941.6 421 941.6 941.6s-421 941.6-941.6 941.6-941.6-421-941.6-941.6c0-520.5 421-941.6 941.6-941.6z",
    style: {
      fill: "#f7931f"
    }
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M522.1 489.5h1022v1022h-1022z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M727.9 932.1c81.8 160.7 213.2 292.2 374.2 374l124.9-125.2c15.6-15.6 38-20.2 57.6-13.9 63.6 21 132 32.4 202.7 32.4 31.5 0 56.8 25.3 56.8 56.8V1455c0 31.5-25.3 56.8-56.8 56.8-533.2 0-965.4-432.2-965.4-965.4 0-31.5 25.6-56.8 56.8-56.8h198.8c31.5 0 56.8 25.3 56.8 56.8 0 70.7 11.4 139.1 32.4 202.7 6.2 19.6 1.7 42-13.9 57.6L727.9 932.1z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.24f717257d82deb1e9c2d02a5c97e72a.svg";
export { ForwardRef as ReactComponent };